var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.7073 5.7075C29.8473 5.56764 29.9427 5.38939 29.9813 5.19531C30.02 5.00122 30.0002 4.80003 29.9244 4.61721C29.8487 4.43439 29.7204 4.27815 29.5558 4.16828C29.3912 4.05841 29.1977 3.99984 28.9998 4H2.99981C2.80192 3.99984 2.60842 4.05841 2.44383 4.16828C2.27923 4.27815 2.15094 4.43439 2.07519 4.61721C1.99944 4.80003 1.97963 5.00122 2.01828 5.19531C2.05693 5.38939 2.1523 5.56764 2.29231 5.7075L14.9998 18.4137V26H10.9998C10.7346 26 10.4802 26.1054 10.2927 26.2929C10.1052 26.4804 9.99981 26.7348 9.99981 27C9.99981 27.2652 10.1052 27.5196 10.2927 27.7071C10.4802 27.8946 10.7346 28 10.9998 28H20.9998C21.265 28 21.5194 27.8946 21.7069 27.7071C21.8945 27.5196 21.9998 27.2652 21.9998 27C21.9998 26.7348 21.8945 26.4804 21.7069 26.2929C21.5194 26.1054 21.265 26 20.9998 26H16.9998V18.4137L29.7073 5.7075ZM5.41356 6H26.5861L24.5861 8H7.41356L5.41356 6ZM15.9998 16.5863L9.41356 10H22.5861L15.9998 16.5863Z",
    fill: "#FF7A00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkIcon);
export default __webpack_public_path__ + "static/media/drink-icon.f778c030536229f3b16ab80d4348b083.svg";
export { ForwardRef as ReactComponent };